/* HIG-147: Versand & Hilfe — open + scroll to the right accordion when arriving with a
 * #anchor (from an Info-Popup "Mehr →" link) or clicking a tile. Native <details> handles
 * open/close; this only adds deep-link + tile behaviour. */
(function () {
  function headerOffset() {
    var h = document.querySelector('.header, header[role="banner"], .site-header, .header__inner');
    if (h) {
      var pos = getComputedStyle(h).position;
      if (pos === 'sticky' || pos === 'fixed') return h.getBoundingClientRect().height + 12;
    }
    return 16;
  }

  function openTarget(hash, smooth) {
    if (!hash || hash.length < 2) return;
    var d = document.getElementById(hash.slice(1));
    if (!d || d.tagName.toLowerCase() !== 'details' || !d.classList.contains('hp-vh__acc')) return;
    d.open = true;
    var top = d.getBoundingClientRect().top + window.scrollY - headerOffset();
    try { window.scrollTo({ top: top, behavior: smooth ? 'smooth' : 'auto' }); }
    catch (e) { window.scrollTo(0, top); }
    d.classList.add('hp-vh--flash');
    setTimeout(function () { d.classList.remove('hp-vh--flash'); }, 1700);
  }

  function init() {
    if (location.hash) {
      // wait a tick so layout is settled before measuring scroll target
      setTimeout(function () { openTarget(location.hash, false); }, 60);
    }
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  window.addEventListener('hashchange', function () { openTarget(location.hash, true); });

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var hash = a.getAttribute('href');
    if (hash && hash.length > 1 && document.getElementById(hash.slice(1))) {
      e.preventDefault();
      if (history.replaceState) history.replaceState(null, '', hash);
      openTarget(hash, true);
    }
  });
})();
